<script>
  import { router } from '@inertiajs/svelte'
  import ApplicationLayout from '../../components/ApplicationLayout/index.svelte'
  import PropertyForm from '../../components/PropertyForm/index.svelte'
  
  let { property_types, addresses = [] } = $props()
</script>

<svelte:head>
  <title>Add New Property | Maset</title>
</svelte:head>

<ApplicationLayout>
  <div class="container mx-auto p-4">
    <div class="max-w-2xl mx-auto">
      <h1 class="text-2xl font-bold mb-6">Add New Property</h1>
      
      <PropertyForm
        property_types={property_types}
        addresses={addresses}
        submitUrl="/properties"
      >
        {#snippet actions()}
          <div>
            <a
              href="/properties"
              class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded mr-2"
            >
              Cancel
            </a>

            <button
              type="submit"
              class="bg-brand-700 hover:bg-brand-800 text-white font-bold py-2 px-4 rounded"
            >
              Save Property
            </button>
          </div>
        {/snippet}
      </PropertyForm>
    </div>
  </div>
</ApplicationLayout>